module.exports = __webpack_public_path__ + "fonts/poppins_bold.5e64a19.ttf";